import React, { Component } from "react";
import NestedMenu from "./NestedMenu";
import { Link } from "react-router-dom";
/*eslint-disable*/
export default class Submenu extends Component {
  state = { _isOpen: false };
  _openHandler = () => {
    this.setState(prevState => ({ _isOpen: !prevState._isOpen }));
  };
  render() {
    const { item } = this.props;
    const { _isOpen } = this.state;
    const { _openHandler } = this;

    return (
      <li className={_isOpen ? "has-child active" : "has-child"}>
        <a onClick={_openHandler}>
          <i className={`fa fa-${item.icon}`} />
          <span>{item.label}</span>
          {item.notifications !== undefined && item.notifications !== 0 ? (
            _isOpen ? null : (
              <span className="label label-success">+{item.notifications}</span>
            )
          ) : null}
        </a>
        <ul>
          {item.submenu.map(subMenuItem => {
            if (subMenuItem.submenu.length === 0) {
              if (subMenuItem.to) {
                return (
                  <li>
                    <Link to={subMenuItem.to}>
                      {subMenuItem.label}
                      {subMenuItem.notifications !== undefined &&
                      subMenuItem.notifications !== 0 ? (
                        <span className="label label-success">
                          +{subMenuItem.notifications}
                        </span>
                      ) : null}
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li>
                    <a onClick={subMenuItem.onClick}>
                      {subMenuItem.label}{" "}
                      {subMenuItem.notifications !== undefined &&
                      subMenuItem.notifications !== 0 ? (
                        <span className="label label-success">
                          +{subMenuItem.notifications}
                        </span>
                      ) : null}
                    </a>
                  </li>
                );
              }
            } else {
              return <NestedMenu item={subMenuItem} />;
            }
          })}
        </ul>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Layout/Sidebar/Submenu/index.js